const abbreviateYear = (year: string | number) => {
  if (String(year).split('').length !== 4) return year
  return '\'' + String(year).slice(2)
}

export default abbreviateYear
